function isContent(x) {
  return !!x && typeof x === 'object' && '__isContent' in x;
}

export { isContent };
